import { ProductDialogHost } from "../src/components/ProductDialogHost";
import { WebStartupGate } from "../src/components/WebStartupGate";
import { StartupStateScreen } from "../src/components/StartupStateScreen";
import { NativeStartupGate } from "../src/components/NativeStartupGate";
import { Ionicons } from "@expo/vector-icons";
import { Platform } from "react-native";
import {
  Poppins_400Regular,
  Poppins_500Medium,
  Poppins_600SemiBold,
  Poppins_700Bold,
  Poppins_800ExtraBold,
  useFonts,
} from "@expo-google-fonts/poppins";
import {
  Tajawal_400Regular,
  Tajawal_500Medium,
  Tajawal_700Bold,
  Tajawal_800ExtraBold,
} from "@expo-google-fonts/tajawal";
import { Stack } from "expo-router";
import * as SplashScreen from "expo-splash-screen";
import { StatusBar } from "expo-status-bar";
import { DarkTheme, ThemeProvider } from "@react-navigation/native";
import * as SystemUI from "expo-system-ui";
import { useEffect } from "react";
import { StartupProvider } from "../src/hooks/useStartup";
import { ActiveAccountProvider } from "../src/hooks/useActiveAccount";
import { useLastNotificationResponse } from "../src/hooks/useLastNotificationResponse";
import { NotificationRoutingProvider } from "../src/components/NotificationRoutingProvider";
import { brand, border, surface, text } from "../src/theme/tokens";
export { ErrorBoundary } from "expo-router";

void SplashScreen.preventAutoHideAsync();
void SystemUI.setBackgroundColorAsync(surface.secondary);

const navigationTheme = {
  ...DarkTheme,
  colors: { ...DarkTheme.colors, primary: brand.primary, background: surface.secondary,
    card: surface.primary, text: text.primary, border: border.subtle, notification: brand.primary },
};

export default function RootLayout() {
  const lastNotificationResponse = useLastNotificationResponse();
  const [fontsLoaded, fontError] = useFonts({
    ...Ionicons.font,
    Poppins_400Regular,
    Poppins_500Medium,
    Poppins_600SemiBold,
    Poppins_700Bold,
    Poppins_800ExtraBold,
    Tajawal_400Regular,
    Tajawal_500Medium,
    Tajawal_700Bold,
    Tajawal_800ExtraBold,
  });

  useEffect(() => {
    if (fontsLoaded || fontError) void SplashScreen.hideAsync();
  }, [fontError, fontsLoaded]);

  if (!fontsLoaded && !fontError) return Platform.OS === "web" ? <StartupStateScreen mode="loading" /> : null;

  return (
    <ThemeProvider value={navigationTheme}>
    <StartupProvider>
    <ActiveAccountProvider>
    <NotificationRoutingProvider lastNotificationResponse={lastNotificationResponse}>
      <ProductDialogHost />
      <StatusBar style="light" hidden={false} />
      <Stack screenLayout={({ children }) => <WebStartupGate navigatorGroups><NativeStartupGate>{children}</NativeStartupGate></WebStartupGate>} screenOptions={{ headerShown: false, contentStyle: { backgroundColor: surface.secondary } }}>
        <Stack.Screen name="(auth)" />
        <Stack.Screen name="(tabs)" />
        <Stack.Screen name="control" />
        <Stack.Screen name="settings" />
        <Stack.Screen name="modal" options={{ presentation: "modal" }} />
      </Stack>
    </NotificationRoutingProvider>
    </ActiveAccountProvider>
    </StartupProvider>
    </ThemeProvider>
  );
}
